import React from "react";

const Footer = () => {
  return (
    <footer
      style={{ background: "#ECF6FF", zIndex: 1000 }}
      className="w-full bg-white rounded-lg shadow-lg dark:bg-gray-800 fixed bottom-0"
    >
      <div className="max-w-screen-xl mx-auto p-4 flex justify-center">
        <span className="text-sm text-gray-500 text-center dark:text-gray-400">
          © {new Date().getFullYear()}{" "}
          <a href="https://www.wowinfotech.com/" className="hover:underline">
            WOWinfotech
          </a>
          . All Rights Reserved.
        </span>
      </div>
    </footer>
  );
};

export default Footer;
